import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ViewingStationMapping} from "@models";
import {NotificationService, SimSystemExtendedService} from "@services";

export interface VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_INPUT extends MatDialogDataBaseInput {
	viewingStationMapping: ViewingStationMapping;
}

export interface VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	updatedViewingStationMapping: ViewingStationMapping;
}

@Component({
	selector: "sim-viewing-station-mapping-configuration-dialog",
	templateUrl: "./viewing-station-mapping-configuration-dialog.component.html",
	styleUrls: ["./viewing-station-mapping-configuration-dialog.component.scss"],
	standalone: false,
})
export class ViewingStationMappingConfigurationDialogComponent
	extends BasicMaterialDialog<
		ViewingStationMappingConfigurationDialogComponent,
		VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_INPUT,
		VIEWING_STATION_MAPPING_CONFIGURATION_DIALOG_OUTPUT
	>
	implements OnInit
{
	hidePassword = true;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _simNotificationService: NotificationService,
		_injector: Injector,
	) {
		super(_injector);
	}

	public async findMacAddressForViewingStation(ip: string) {
		if (!ip) {
			return;
		}
		const macAddressResult = await this._simSystemService.getMacAddress(ip);
		if (macAddressResult) {
			this.data.viewingStationMapping.macAddress = macAddressResult;
		} else {
			this._simNotificationService.notifyError("Could not find a MAC address for the given IP address.");
		}
	}

	public saveViewingStationMapping() {
		this.close({
			action: "ok",
			updatedViewingStationMapping: this.data.viewingStationMapping,
		});
	}
}
